import React, { useEffect, useRef, useState } from 'react'
import useSound from 'use-sound'
import bell from '../../../assets/sounds/message.mp3'
import { Button, Input, Space, TimePicker, message } from 'antd'
import { EditOutlined } from '@ant-design/icons'

import dayjs from 'dayjs'
import API from '../../../utils/api'
import { useToken } from '../../hooks'
import { Text, View } from '../../../styles/reactnative'

const TimeSave = ({ text, columnname, data, mutate }) => {
	const [modify, setModify] = useState(false)
	const [time, setTime] = useState<any>(dayjs(text || '00:00:00', 'HH:mm:ss'))
	const { data: token } = useToken()

	let savedata = {}

	if (columnname === 'starttime') {
		savedata = {
			starttime: time?.format('HH:mm:ss'),
		}
	} else if (columnname === 'endtime') {
		savedata = {
			endtime: time?.format('HH:mm:ss'),
		}
	} else if (columnname === 'starttime2') {
		savedata = {
			starttime2: time?.format('HH:mm:ss'),
		}
	} else if (columnname === 'endtime2') {
		savedata = {
			endtime2: time?.format('HH:mm:ss'),
		}
	} else if (columnname === 'starttime_break') {
		savedata = {
			starttime_break: time?.format('HH:mm:ss'),
		}
	} else if (columnname === 'endtime_break') {
		savedata = {
			endtime_break: time?.format('HH:mm:ss'),
		}
	}

	const save = () => {
		API.send('PUT', '/admin/exchange/time', token + '', {
			id: data?.id,
			...savedata,
		}).then(res => {
			setModify(false)
			setTimeout(() => {
				mutate()
			}, 100)
			message.success('수정되었습니다.')
		})
	}

	if (!modify) {
		return (
			<Text style={text ? {} : { color: '#aaa' }}>
				{text || '설정안됨'}
				<Button
					type="ghost"
					size="small"
					icon={<EditOutlined />}
					onClick={() => setModify(true)}
				/>
			</Text>
		)
	} else {
		return (
			<Space.Compact>
				<TimePicker
					defaultValue={time}
					onChange={e => {
						setTime(e || dayjs('00:00:00'))
					}}
				/>
				<Button
					type="primary"
					size="small"
					onClick={() => {
						save()
					}}>
					수정
				</Button>
			</Space.Compact>
		)
	}
}

export default TimeSave
